<template>
  <v-app id="inspire">
    <v-content>
      <v-container>
        <v-row align="center" justify="center">
          <v-col cols="12" sm="8" md="4">
            <v-card class="elevation-12">
              <v-toolbar color="primary" dark flat>
                <v-toolbar-title><h3>登入</h3></v-toolbar-title>
              </v-toolbar>
              <v-card-text>
                <v-form>
                  <v-text-field
                    label="Login"
                    name="login"
                    prepend-icon="person"
                    type="text"
                    autofocus
                    :rules="[rules.required, rules.userCounter]"
                    :loading="status.logging"
                    validate-on-blur
                    v-model="user"
                  ></v-text-field>

                  <v-text-field
                    id="password"
                    label="Password"
                    name="password"
                    prepend-icon="lock"
                    :append-icon="
                      showPassword ? 'visibility' : 'visibility_off'
                    "
                    :type="showPassword ? 'text' : 'password'"
                    :rules="[rules.required, rules.passCounter]"
                    :loading="status.logging"
                    validate-on-blur
                    v-model="pass"
                    @click:append="showPassword = !showPassword"
                  />
                  <v-alert
                    v-if="status.loginFaile"
                    dense
                    outlined
                    type="error"
                    :icon="status.err.icon"
                    :color="status.err.color"
                  >
                    {{ status.err.text }}
                    <!-- 帳號或密碼錯誤 -->
                  </v-alert>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-spacer />
                <v-btn
                  class="my-btn"
                  data-test="login-btn"
                  color="primary"
                  @click="handleOnLogin"
                  ><h3>登入</h3></v-btn
                >
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import { mapActions, mapState } from 'vuex'
export default {
  props: {
    source: String
  },
  data() {
    return {
      showPassword: false,
      rules: {
        required: v => !!v || 'Required.',
        userCounter: v => !(v && v.length < 5) || 'Min 5 characters.',
        passCounter: v => !(v && v.length < 6) || 'Min 6 characters.'
      },
      user: '',
      pass: ''
      // user: null,
      // pass: null
    }
  },
  computed: {
    ...mapState('account', ['status'])
  },
  methods: {
    ...mapActions('account', ['login']),
    handleOnLogin() {
      const { user, pass } = this
      if (!user || !pass) return
      if (user.length < 5 || pass.length < 6) return
      this.login({ user, pass })
    }
  },
  created() {
    if (process.env.NODE_ENV === 'development') {
      if (window.location.pathname === '/adminLogin') {
        this.user = 'test01'
        this.pass = '123456'
      } else {
        this.user = 'agent01'
        this.pass = '123456'
      }
    }
  }
}
</script>

<style scoped></style>
